import { useEffect, useRef, useState } from 'react';

import { ZIndex } from '@rover/constants/src/styles/ZIndex';
import { Box } from '@rover/kibble/core';

import type { StickyGalleryToolbarProps } from './StickyGalleryToolbar.common';

// Sticking at -1px pushes the bar one pixel out of view once it sticks, which the observer reads.
const STUCK_OFFSET = '-1px';

const StickyGalleryToolbar = ({
  children,
  contrast = false,
}: StickyGalleryToolbarProps): JSX.Element => {
  const ref = useRef<HTMLElement>(null);
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || typeof IntersectionObserver === 'undefined') return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => setIsStuck(entry.intersectionRatio < 1),
      { threshold: [1] }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Box
      position="sticky"
      top={STUCK_OFFSET}
      zIndex={ZIndex.STICKY_HEADER.toString()}
      width="100%"
      py="3x"
      background={contrast ? undefined : 'primary'}
      sx={{
        backgroundColor: contrast ? 'neutral.900' : undefined,
        boxShadow: isStuck && !contrast ? 'elevation_high' : 'none',
      }}
      ref={ref}
      testID="sticky-gallery-toolbar"
    >
      {children}
    </Box>
  );
};

export default StickyGalleryToolbar;
